import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { CargoCadastroForm } from "../../components/cargo_cadastro_form";

import PrimaryButton from "../../../../../common/components/primary_button";
import { useForm } from "react-hook-form";

/**
 * CargoCadastroDialog
 */

type Props = {
  openDialog: boolean,
  onClose: () => void,
  onSave: () => void,
};

export const CargoCadastroDialog = ({
  openDialog,
  onClose,
}: Props) => {
  const hookForm = useForm();
  return (
    <Dialog
      open={openDialog}
      onClose={onClose}
      component={"form"}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "50rem",
          },
        },
      }}>
      <DialogTitle>
        Novo Cargo
      </DialogTitle>
      <DialogContent>
        <CargoCadastroForm
          hookForm={hookForm}
        />
      </DialogContent>
      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div className="flex flex-row w-[180px] gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={onClose}>
                Cancelar
              </h1>
            </div>
            <PrimaryButton
              type="submit"
              buttonColor="primary-green">
              Salvar
            </PrimaryButton>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}